'use strict';

var React = require('react');

var SvgBehaviorMinor = function SvgBehaviorMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.275 9.038a1 1 0 0 0-1.236 1.237l1.714 6a1 1 0 0 0 1.88.119l1.129-2.632 2.632-1.129a1 1 0 0 0-.12-1.88l-6-1.715Zm-.275-6.038a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Zm-4.95 2.05a1 1 0 0 1 1.414 0l1.415 1.414a1 1 0 0 1-1.415 1.415l-1.414-1.415a1 1 0 0 1 0-1.414Zm9.9 0a1 1 0 0 1 0 1.414l-1.414 1.415a1 1 0 1 1-1.415-1.415l1.415-1.414a1 1 0 0 1 1.414 0Zm-7.071 7.071a1 1 0 0 1 0 1.415l-1.415 1.414a1 1 0 1 1-1.414-1.414l1.414-1.415a1 1 0 0 1 1.415 0Zm-.879-2.121a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1Z"
  }));
};

exports.SvgBehaviorMinor = SvgBehaviorMinor;
